export default "__VITE_ASSET__CroXYT3Q__"